module.exports = __webpack_public_path__ + "img/product_chart_7.437dc722.png";